function spawnMeteor(body, times = Infinity) {
    if (times <= 0) return; // Stop after X meteors

    // 1) Create an <img> for your SVG
    const drop = document.createElement("img");
    // Absolute path so it resolves on nested routes too (e.g.
    // /view/curations/:id) — a relative "img/meteor.svg" there 404s and the
    // broken <img> renders as a stretched vertical line.
    drop.src = `${process.env.PUBLIC_URL || ''}/img/meteor.svg`;
    drop.classList.add("meteor-icon");

    // 2) Apply random properties (width, position, animation delay, etc.)
    const size = Math.random() * 15;
    const posX = Math.floor(Math.random() * window.innerWidth);
    const delay = Math.random() * -20;
    const duration = Math.random() * 25;

    // For width, you may need more than 0.1+size if the SVG is very small:
    drop.style.width = `${0.1 + size}px`;
    drop.style.left = `${posX}px`;
    drop.style.animationDelay = `${delay}s`;
    drop.style.animationDuration = `${1 + duration}s`;

    // 3) Listen for the animation to end, then remove & spawn next
    drop.addEventListener("animationend", () => {
        drop.remove();
        spawnMeteor(body, times - 1); // create next meteor
    });

    // 4) Append <img> to #meteor-animation container
    body.appendChild(drop);
}

export function initMeteorAnimation() {
    const body = document.querySelector("#meteor-animation");

    // Start the chain of meteors
    spawnMeteor(body, 25); // e.g. 5 times, or Infinity for never-ending
    return true;
}
